/**
 * dominantPastoralImpulse.js — FASE R7.
 *
 * Converts a dominant signal into a pastoral impulse + compact instruction.
 *
 * A pastor responding from intuition doesn't think "the dominant signal is grief."
 * They feel: "this person needs to be accompanied."
 * This module captures that natural pastoral instinct.
 *
 * Output instruction: ≤60 chars. No analytical framing.
 */

const IMPULSE_MAP = {
  crisis:             { impulse: "proteger",   instruction: "Quédate con la parte más humana." },
  grief:              { impulse: "acompañar",  instruction: "No apresures resolución." },
  exhaustion:         { impulse: "sostener",   instruction: "Sostén más de lo que explicas." },
  conflict:           { impulse: "desescalar", instruction: "No resuelvas todo de una vez." },
  silent_tension:     { impulse: "nombrar",    instruction: "Haz espacio a lo no dicho." },
  continuity_concern: { impulse: "recordar",   instruction: "Responde desde lo que ya conoces." },
  spiritual_process:  { impulse: "permanecer", instruction: "Haz espacio." },
  reflection:         { impulse: "contemplar", instruction: "Responde reflexivo y sin prisa." },
  logistics:          { impulse: "resolver",   instruction: "Responde simple y directo." },
  simple_presence:    { impulse: "no_forzar",  instruction: null },
};

/**
 * @param {string} dominantSignal
 * @returns {{ impulse: string, instruction: string|null }}
 */
export function resolvePastoralImpulse(dominantSignal) {
  return IMPULSE_MAP[dominantSignal] ?? IMPULSE_MAP["simple_presence"];
}
